import { Routes, Route } from "react-router-dom";
import { useSelector } from "react-redux";
import { useEffect, useRef } from "react";
import "./App.css";
import Main from "./components/MainComponent";
import AuthComponent from "./components/AuthComponent";
import AddressComponent from "./components/AddressComponent";
import PaymentComponent from "./components/PaymentComponent";
import {
  store,
  setShopDomain,
  setShopifyCart,
  setUserShopifyDetails
} from "./store";
import { AddAddress } from "./components/AddressComponent/templates/AddAddress";
import PaymentType from "./components/PaymentTypeComponent/paymentType";
import {
  initializeCashkoro,
  initializeFbPixel,
  initializeGAds,
  initializeGtag,
  setAnalyticsIds
} from "./utils";
import { useGetStoreConfig, useSyncUser } from "./hooks";
import { useCheckoutMutation } from "./hooks/checkout-mutation.hook";
import { ReactComponent as HomeIcon } from "./assets/home-logo.svg";
import { ReactComponent as LogoIcon } from "./assets/logo.svg";

// Function to handle the message event
export const handleMessageEvent = (e, checkoutMutation, checkoutRef) => {
  if (checkoutRef.current) return;
  if (e.type === "message") {
    const { analytics, cart, customer } = e.data;

    // Store analytics IDs
    if (analytics?.google) setAnalyticsIds(analytics);

    if (analytics?.google?.gads_id)
      initializeGAds(analytics.google.gads_id, analytics.google.ga4_client_id);

    if (analytics?.google?.ga4_id)
      initializeGtag(analytics.google.ga4_id, analytics.google.ga4_client_id);

    if (analytics?.fb?.pixel_id) initializeFbPixel(analytics.fb.pixel_id);

    if (!cart) return;
    const domain = e.origin.replace("https://", "");
    store.dispatch(setShopifyCart(cart));
    store.dispatch(setShopDomain(domain));
    if (domain && cart.token) checkoutMutation({ shopDomain: domain, cart });
    // eslint-disable-next-line no-param-reassign
    checkoutRef.current = true;

    if (customer) {
      if (customer.phoneNumber?.length > 10)
        customer.phoneNumber = customer.phoneNumber.slice(-10);

      if (customer.id) customer.shopifyId = customer.id;

      store.dispatch(setUserShopifyDetails(customer));
    }
    window.parent.postMessage({ dataReceived: true }, `https://${domain}`);
    initializeCashkoro();
  }
};

export default function App() {
  const eventRef = useRef(false);
  const order = useSelector((state) => state.order);
  const { mutate: checkoutMutation, status: checkoutStatus } =
    useCheckoutMutation();
  const { status: configStatus } = useGetStoreConfig(
    order?.shopDomain,
    store.dispatch
  );
  useSyncUser(store.dispatch);

  useEffect(() => {
    window.addEventListener("message", (e) =>
      handleMessageEvent(e, checkoutMutation, eventRef)
    );
  }, []);

  if (
    ["pending", "idle"].includes(configStatus) ||
    ["pending", "idle"].includes(checkoutStatus)
  )
    return (
      <div className="checkout-loading">
        <h2 className="loading-head">
          Hold tight, rolling you smoothly to checkout...{" "}
        </h2>
        <HomeIcon height="80" width="50" fill="black" />
        <div className="footer-loader">
          <p>Powered By</p>
          <LogoIcon fill="black" height="20" width="125" />
        </div>
      </div>
    );

  // TODO:: if checkout api fails give error message(or retry by own)

  return (
    <Routes>
      <Route path="/" element={<Main />}>
        <Route path="login" element={<AuthComponent />} />
        <Route path="address" element={<AddressComponent />} />
        <Route path="add-address" element={<AddAddress />} />
        <Route path="choose-type" element={<PaymentType />} />
        <Route path="payment" element={<PaymentComponent />} />
      </Route>
    </Routes>
  );
}
